// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"276d8255","628":"4a001de2"}[chunkId] + ".chunk.js";
};